import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { Card, Row, Col, Steps } from "antd";
import Kirim from "./Kirim";
import OTP from "./OTP";
import Selesai from "./Selesai";

const { Step } = Steps;

const App = () => {
  const { isLoggedIn } = useSelector((state) => state.auth);
  const [current, setCurrent] = useState(0);
  const [email, setEmail] = useState("");
  const [wa, setWa] = useState("");
  const [via, setVia] = useState("");

  const next = () => {
    setCurrent(current + 1);
  };

  const prev = () => {
    setCurrent(current - 1);
  };

  const steps = [
    {
      title: "Kirim Kode OTP",
      content: (
        <Kirim
          email={email}
          wa={wa}
          setEmail={setEmail}
          setWa={setWa}
          setCurrent={setCurrent}
          setVia={setVia}
        />
      ),
    },
    {
      title: "Reset Password",
      content: <OTP via={via} email={email} wa={wa} setCurrent={setCurrent} />,
      disabled: true,
    },
    {
      title: "Selesai",
      content: <Selesai email={email} />,
      disabled: true,
    },
  ];

  const dispatch = useDispatch();

  if (isLoggedIn) {
    return <Navigate to="/" />;
  }

  const onChange = (value) => {
    console.log("onChange:", value);
    setCurrent(value);
  };

  return (
    <Row justify="center" align="middle" style={{ height: "100%" }}>
      <Col style={{ width: "70%" }}>
        <Card title="Lupa Password Akun Ina-Geoportal">
          <Steps current={current} type="navigation" onChange={onChange}>
            {steps.map((item) => (
              <Step
                key={item.title}
                title={item.title}
                disabled={item.disabled}
              />
            ))}
          </Steps>

          <div className="steps-content">{steps[current].content}</div>
          {/*
          <div className="steps-action" style={{ marginTop: 24 }}>
            {current > 0 && (
              <Button style={{ marginLeft: 8 }} onClick={prev}>
                Previous
              </Button>
            )}
            {current < steps.length - 1 && (
              <Button type="primary" onClick={next}>
                Next
              </Button>
            )}
            {current === steps.length - 1 && (
              <Button type="primary" onClick={() => console.log("Submit form")}>
                Submit
              </Button>
            )}
          </div>
          */}
        </Card>
      </Col>
    </Row>
  );
};
export default App;
